import SideMenu from "./SideMenu";
import type { SideMenuProps } from "./SideMenu.d";
import SideMenuItem from "./SideMenuItem/SideMenuItem";

export { SideMenu, SideMenuItem };
export type { SideMenuProps };
